/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserManagementDataDto } from '../models/UserManagementDataDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserManagementControllerService {
    /**
     * @param userId
     * @returns void
     * @throws ApiError
     */
    public static rejectCoach(
        userId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/user-management/reject-coach/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @returns void
     * @throws ApiError
     */
    public static approveCoach(
        userId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/user-management/approve-coach/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param sportsClubId
     * @returns UserManagementDataDto OK
     * @throws ApiError
     */
    public static getSportsClubUsers(
        sportsClubId: number,
    ): CancelablePromise<UserManagementDataDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user-management/sports-club/{sportsClubId}/users',
            path: {
                'sportsClubId': sportsClubId,
            },
        });
    }
    /**
     * @param sportsClubId
     * @param emails
     * @returns void
     * @throws ApiError
     */
    public static sendInvitations(
        sportsClubId: number,
        emails: string[],
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user-management/send-invitations',
            body: {
                sportsClubId: sportsClubId,
                emails: emails,
            },
        });
    }
    /**
     * @param sportsClubId
     * @returns PendingInvitationDto[] OK
     * @throws ApiError
     */
    public static getPendingInvitations(
        sportsClubId: number,
    ): CancelablePromise<Array<{
        email: string;
        emailSent: boolean;
        createdAt: string;
        emailSentAt: string | null;
        retryCount: number;
        lastError: string | null;
    }>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user-management/sports-club/{sportsClubId}/pending-invitations',
            path: {
                'sportsClubId': sportsClubId,
            },
        });
    }
    /**
     * @param sportsClubId
     * @param email
     * @returns void
     * @throws ApiError
     */
    public static resendInvitation(
        sportsClubId: number,
        email: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user-management/resend-invitation',
            body: {
                sportsClubId: sportsClubId,
                email: email,
            },
        });
    }
    /**
     * @param teamId
     * @param coachId
     * @returns void
     * @throws ApiError
     */
    /**
     * @param coachId
     * @param teamIds
     * @returns void
     * @throws ApiError
     */
    public static reassignCoach(
        coachId: number,
        teamIds: number[],
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/user-management/coaches/{coachId}/reassign',
            path: {
                'coachId': coachId,
            },
            body: {
                teamIds: teamIds,
            },
        });
    }
    public static removeCoachFromTeam(
        teamId: number,
        coachId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/user-management/teams/{teamId}/coaches/{coachId}',
            path: {
                'teamId': teamId,
                'coachId': coachId,
            },
        });
    }
}
